import { Config } from 'driver.js';
import { defineMessage } from 'react-intl';

/** Message for the "Next" button in driver.js popover. */
export const driverJsNextBtn = defineMessage({
  id: 'tours.driver.next',
  defaultMessage: 'Siguiente',
});

/** Message for the "Previous" button in driver.js popover. */
export const driverJsPrevBtn = defineMessage({
  id: 'tours.driver.previous',
  defaultMessage: 'Anterior',
});

/** Message for the "Done" / "Close" button on the last step. */
export const driverJsDoneBtn = defineMessage({
  id: 'tours.driver.done',
  defaultMessage: 'Listo',
});

/**
 * Progress text template. Driver.js expects the string to contain {{current}} and {{total}}.
 * We pass those as values so ICU outputs them literally; driver.js then replaces them at runtime.
 * Example output: "{{current}} de {{total}}" → driver.js shows "1 de 3".
 */
export const driverJsProgressText = defineMessage({
  id: 'tours.driver.progress',
  defaultMessage: '{current} de {total}',
});

/** Label for the "NEW" chip shown above the popover title. */
export const driverJsNewChip = defineMessage({
  id: 'tours.driver.new',
  defaultMessage: 'Nuevo',
});

type Translate = (
  message: ReturnType<typeof defineMessage>,
  values?: Record<string, string | number>,
) => string;

/** Values passed so the progress message contains driver.js placeholders literally. */
const DRIVER_PROGRESS_VALUES = {
  current: '{{current}}',
  total: '{{total}}',
} as const;

/**
 * Returns driver.js config options with localized button and progress text.
 * Merge the result into your driver Config so the tour UI is translated.
 */
export function getDriverJsLabels(
  t: Translate,
): Pick<Config, 'nextBtnText' | 'prevBtnText' | 'doneBtnText' | 'progressText'> {
  return {
    nextBtnText: t(driverJsNextBtn),
    prevBtnText: t(driverJsPrevBtn),
    doneBtnText: t(driverJsDoneBtn),
    progressText: t(driverJsProgressText, DRIVER_PROGRESS_VALUES),
  };
}
